// components/common/RefreshButton.jsx
import React from "react";
import { RefreshCcw } from "lucide-react";
import BlueButton from "./BlueButton";

export default function RefreshButton({ onClick }) {
  return (
    <BlueButton
      onClick={onClick}
      className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 sm:w-auto"
    >
      <RefreshCcw size={14} />
      <span className="hidden md:block">Refresh</span>
    </BlueButton>
  );
}
